import { Control, FieldErrors } from "react-hook-form";
import NumberInput from "./NumberInput";
import { Grid, Typography } from "@mui/material";

export function RopMonthValuesForm(props: {
  title: string;
  fieldName: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  sx?: React.CSSProperties;
  required?: boolean;
}) {
  const { title, fieldName, control, errors, required } = props;
  const months: { label: string; value: string }[] = [
    {
      label: "Janeiro",
      value: "jan",
    },
    {
      label: "Fevereiro",
      value: "feb",
    },
    {
      label: "Março",
      value: "mar",
    },
    {
      label: "Abril",
      value: "apr",
    },
    {
      label: "Maio",
      value: "may",
    },
    {
      label: "Junho",
      value: "jun",
    },
    {
      label: "Julho",
      value: "jul",
    },
    {
      label: "Agosto",
      value: "aug",
    },
    {
      label: "Setembro",
      value: "sep",
    },
    {
      label: "Outubro",
      value: "oct",
    },
    {
      label: "Novembro",
      value: "nov",
    },
    {
      label: "Dezembro",
      value: "dec",
    },
  ];
  return (
    <>
      <Grid item xs={12} textAlign={"start"}>
        <Typography
          variant="h6"
          sx={{
            borderBottom: "1px solid #ccc",
            paddingBottom: 1,
            marginBottom: "15px",
          }}
        >
          {title}
        </Typography>
        {/* <Typography variant="h6">{title}</Typography> */}
      </Grid>
      {months.map((month, index) => (
        <Grid key={index} display={"flex"} item xl={2} xs={6} sm={4} md={3}>
          <NumberInput
            fieldName={`${fieldName}.${month.value}`}
            label={`${month.label}${required ? " *" : ""}`}
            control={control}
            errors={errors}
            sx={{
              width: "100%",
              maxWidth: "280px",
            }}
          />
        </Grid>
      ))}
    </>
  );
}
